import parallax_m from '../common/parallax-m';

import ScrollMagic from "scrollmagic";
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

import '../../plugins/jquery.fitimg.js';


$(".l-footer-image-sp").fitimg({
  mode: "cover",
  valign: 'center',
  img: {css: {opacity: 1}}
});
$(".l-footer-image-pc").fitimg({
  mode: "cover",
  valign: 'bottom',
  img: {css: {opacity: 1}}
});

// import Rellax from "rellax";
// var rellax = new Rellax('.rellax');
var controller = new ScrollMagic.Controller();

var scene_search_1 = new ScrollMagic.Scene({
  triggerElement: ".l-footer-image" ,
  triggerHook: 'onEnter',
  // duration: 800,
  offset :0
})
// .addIndicators()
.addTo(controller);

scene_search_1.on('enter', ()=>{
  parallax_m('.l-footer-image-pc img', scene_search_1.scrollOffset(), 7, 100);
  // parallax_m('.l-footer-image-sp img', scene_search_1.scrollOffset(), 7, 30);
});
